import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './../static/assets/css/index.css';
import './../static/assets/css/load.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import "react-image-gallery/styles/css/image-gallery.css";
import App from './components/App';
import { Provider } from 'react-redux';
import store from './store'; 

ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>,
    document.getElementById('app')
  );